import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import SvgIcon from "@mui/material/SvgIcon";
const FilterFilledIcon = (t0)=>{
    const $ = c(6);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M12.72 2q.236 0 .42.002c.367.007.594.034.788.142a1 1 0 0 1 .11.074q.059.046.115.103a1.2 1.2 0 0 1 .275.393.9.9 0 0 1 .069.324c.01.197-.021.434-.066.779l-.044.309c-.08.5-.19.954-.327 1.371a7 7 0 0 1-.248.652l-.016.036a7 7 0 0 1-.535.977l-.111.17a7 7 0 0 1-.165.225q-.052.071-.107.142a8 8 0 0 1-.178.215l-.117.139q-.084.094-.17.184l-.16.17-.167.166-.17.165-.12.11q-.459.422-.975.839-.402.324-.833.664v1.443c0 .35-.058.69-.16 1.01l-.025.08a3 3 0 0 1-.1.252q-.03.067-.063.133l-.063.123-.061.104q-.037.063-.077.125l-.071.102-.088.12-.075.092q-.052.06-.106.119l-.074.079a3.4 3.4 0 0 1-.647.51l-.137.078q-.045.026-.091.05-.086.041-.173.078l-.086.039q-.063.024-.128.045-.199.072-.41.12a1.1 1.1 0 0 1-.363.016 1 1 0 0 1-.115-.02l-.055-.015-.052-.016q-.027-.008-.052-.018l-.075-.033-.023-.011a1.1 1.1 0 0 1-.311-.235q-.023-.023-.043-.047l-.037-.05-.039-.055-.01-.018a1 1 0 0 1-.049-.084l-.012-.024-.034-.084q-.005-.008-.008-.018l-.01-.03-.015-.05-.013-.05a1 1 0 0 1-.028-.245v-3.615c-1.007-.794-1.9-1.503-2.622-2.33a8 8 0 0 1-.576-.742 7 7 0 0 1-.484-.829c-.327-.66-.57-1.418-.715-2.325q-.023-.152-.044-.308c-.072-.552-.107-.828.003-1.103a1.24 1.24 0 0 1 .501-.57c.13-.072.273-.108.463-.126S2.963 2 3.28 2z",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== height || $[3] !== t1 || $[4] !== width) {
        t2 = /*#__PURE__*/ jsx(SvgIcon, {
            width: width,
            height: height,
            viewBox: "0 0 20 20",
            children: t1
        });
        $[2] = height;
        $[3] = t1;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
export { FilterFilledIcon };
